import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { App } from "./App";
import { ErrorBoundary } from "./components";
import { AuthProvider } from "./hooks";
import { msalInstance } from "./config/auth";
import "./index.css";

// Initialize React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize MSAL and handle any redirect response before rendering
msalInstance.initialize().then(async () => {
  await msalInstance.handleRedirectPromise();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <FluentProvider theme={webLightTheme}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </ErrorBoundary>
        </QueryClientProvider>
      </FluentProvider>
    </React.StrictMode>,
  );
});
